import request from "@/utils/request";

export default function list(params) {
    return request({
        url: `/storeProductSpecificationValueCoverImg/agency/list`,
        method: 'post',
        data:params
    })
}
